import styled from 'styled-components'

export const Container = styled.div`
   margin: 30px;
`

export const AddButtonContainer = styled.div`
   margin-left: 30px;
`
